module.exports = __webpack_public_path__ + "static/media/Azure_AMA_Guest_Metrics_Serra_Labs.d8fc93a3.pdf";